<template>
  <div class="setting">
    <div class="content">
      <div class="card">
        <div class="menu justify-between">
          <div class="flex align-center">
            <div class="title" :class="{active:page === 'feedback'}" @click="page = 'feedback'">意见反馈</div>
            <div class="title" :class="{active:page === 'about'}" @click="page = 'about'">关于我们</div>
          </div>
          <div @click="openHistory"
            class="point bg-theme text-whitep  padding-tb-6 padding-lr-10 radius-4 text-white">
            反馈记录
          </div>

        </div>
        <Form class="form" label-position="top" v-if="page === 'feedback'">
          <FormItem label="反馈类型">
            <tabNav :list="feedbackTypeList" v-model="formItem.single_id"></tabNav>
          </FormItem>
          <FormItem label="反馈描述">
            <Input class="input" :rows="4" maxlength="200" type="textarea" v-model="formItem.instruction"
              placeholder="请输入反馈描述"></Input>
          </FormItem>
          <FormItem label="图片:">
            <Upload :max='6' :more.sync=img_more :imgList.sync="formItem.img"></Upload>
          </FormItem>

          <div class="tips">请上传应用截图，最多上传6张</div>
          <FormItem label="请留下您的联系方式">
            <Input class="input" number :maxlength="11" :value="formItem.phone" v-model="formItem.phone"
              placeholder="手机号"></Input>
          </FormItem>
          <div class="footer">
            <Button type="primary" @click="submit()" style="width: 100px">提交</Button>
          </div>
        </Form>
        <div class="about" v-if="page === 'about'">
          <Avatar icon="ios-person" :src.sync="logo" size="60" />
          <div class="desc">{{copyright}}</div>
          <div class="tel desc" style="margin-top: 20px">{{name}}</div>
          <!--          <div class="desc" style="margin-top: 10px">联系地址：河南省郑州市</div>-->
          <!--          <div class="desc" style="margin-top: 10px">商务合作：13011112222</div>-->
        </div>
      </div>
    </div>
    <!-- 反馈记录-->
    <div class="mask" @click="historyTableVisible=false" v-if="historyTableVisible"></div>
    <div class="box-content-map bg-white radius-6 ovflowHidden  " v-if="historyTableVisible">
      <div class="     ">
        <div class="flex align-center justify-between padding map-set ">
          <div class="fs16 bold">
            反馈记录
          </div>
          <span class="  fs20   text-333 point" @click="historyTableVisible=false">
            <i class="el-icon-close"></i>
          </span>
        </div>
        <!-- 列表 -->
        <div class="padding-lr-40 ovflowScrolly" v-loading="loading" style="height: 60vh;" v-if="historyList.length>0">
          <div class="   solid-bottom padding-tb-20 point" v-for="(item,index) in historyList" :key='index'>
            <div class="flex ">
              <div class="margin-right-10">
                <img :src="item.head_img" alt="" class="block-52 radius-100">
              </div>
              <div class="w90">
                <p class="" style="word-wrap: break-word;">{{item.instruction}}</p>
                <p class="padding-top-15 text-333">联系方式：{{item.phone}}</p>
                <div class="flex align-center justify-between">
                  <p class="padding-top-10 text-theme" v-if="item.single">{{item.single.name}}</p>
                  <p class="padding-top-10 text-999">{{item.created_at}}</p>
                </div>
              </div>
            </div>
            <div class="flex align-center margin-top-10 flex-wrap">
              <el-image style="width: 100px; height: 100px" class="margin-right-10" v-for="(tm,ix) in item.img"
                :key='ix' :src="tm" :preview-src-list="item.img">
              </el-image>
            </div>
            <div class="bg-f8 padding-tb-10 padding-lr-10 margin-top-10" v-if='item.reply&&item.reply.content'>
              平台回复：{{item.reply.content}}
            </div>

          </div>
        </div>
        <el-empty :image-size="120" v-if="historyList.length==0"></el-empty>
        <PageComponents :total="tableShow.listCount" :current="tableShow.currentPage" :pageSize="tableShow.pageSize"
          @on-change="changePage"></PageComponents>
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderComponents from '../../components/header'
  import PageComponents from '../../components/page'
  import tabNav from '../../components/tabNav'
  import Upload from '../../components/upload'

  export default {
    name: 'setting',
    components: {
      HeaderComponents,
      PageComponents,
      tabNav,
      Upload,
    },
    data() {
      return {
        logo: '',
				loading: true,
        tableShow: {
          currentPage: 1,
          pageSize: 10,
          listCount: 0
        },
        name: '',
        historyTableVisible: false, //历史记录
        version: '',
        copyright: '',
        page: 'feedback',
        img_more: true,
        historyList: [], //历史记录
        formItem: {
          img: [],
          single_id: 0,
          instruction: "",
          phone: "",
        },
        feedbackTypeList: []
      }
    },
    created() {
      let vm = this
      vm.getHistory()
      this.$request('61177c8371904', {
        scene: "3",
      }).then(res => {
        vm.feedbackTypeList = []
        res.data.data.forEach(function(item) {
          vm.feedbackTypeList.push({
            value: item.id,
            label: item.name
          })
          vm.formItem.single_id = vm.feedbackTypeList[0].value
        })

      })


      this.$request('6152db7703e21', {}).then(res => {
        vm.logo = res.data.data.logo
        vm.copyright = res.data.data.copyright
        vm.name = res.data.data.name
        console.log(res)
      })
    },
    methods: {
      // 6119cb00c3e66
      openHistory() {
        this.historyTableVisible = true
        this.tableShow.currentPage = 1
        this.getHistory()
      },
      getHistory() {
        let vm = this
        vm.loading = true
        this.$request('6119cb00c3e66', {
          page: vm.tableShow.currentPage,
          size: vm.tableShow.pageSize + '',
        }).then(res => {
          vm.tableShow.listCount = res.data.data.count
          vm.historyList = res.data.data.list
        }).finally(() => {
					vm.loading = false
        })
      },
      changePage(page) {
				this.loading = true
        this.tableShow.currentPage = page
        this.getHistory()
      },

      submit() {

        if (this.formItem.single_id == 0) {
          return this.$message.error('请选择类型')
        }

        if (this.formItem.instruction == "") {
          return this.$message.error('请输入描述')
        }
        var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g")
        if (this.formItem.phone) {
          if (reg.test(this.formItem.phone)) {
            return this.$message.error('联系方式不能包含中文')
          }
        }

        this.$util.throttle(() => {
          this.$request('6119cad48af6c', {
            single_id: this.formItem.single_id.toString(),
            instruction: this.formItem.instruction,
            phone: this.formItem.phone+'',
            img: JSON.stringify(this.formItem.img),
          }).then(res => {
            this.formItem.phone = ''
            this.formItem.instruction = ''
            this.formItem.img = []
            this.tableShow.currentPage = 1
            this.getHistory()
            return this.$message.success('提交成功')
          })
        }, 2000, true)
      }
    }
  }
</script>

<style lang="less">
  .setting {

    .ivu-steps-title {
      margin-top: 2px;
    }

    .content {
      background-color: #f7f8fa;
    }

    .card {
      background-color: #FFFFFF;
      padding: 20px;
      border-radius: 3px;

      .menu {
        display: flex;

        .title {
          font-size: 18px;
          color: #333;
          position: relative;
          margin-right: 30px;
          cursor: pointer;


        }

        .active {
          font-weight: 450;

          &::after {
            content: '';
            position: absolute;
            bottom: -10px;
            left: 0;
            width: 70px;
            height: 3px;
            background-color: #FB9E2F;
          }
        }
      }


      .form {
        margin-top: 40px;

        .input {
          width: 300px;
        }

        .tips {
          color: #999999;
          font-size: 12px;
          margin-bottom: 30px;
        }

        .footer {
          margin-top: 30px;
          margin-bottom: 20px;
        }
      }

      .about {
        margin-top: 40px;

        .desc {
          font-size: 14px;
          font-weight: 400;
          line-height: 30px;
          color: #666666;
          margin-top: 20px;
        }
      }
    }
  }

  .box-content-map {
    position: fixed;
    left: 0;
    right: 0;
    width: 45%;
    top: 10%;
    height: 83vh;
    z-index: 1510;
    margin: auto;
  }
</style>
